// extracted by mini-css-extract-plugin
module.exports = {"modal":"modals-LosslessSupportModal__modal--37Szl","downloadLink":"modals-LosslessSupportModal__downloadLink--3ZpB1"};